import { BaseEntity } from './BaseEntity';

/**
 * 树节点
 * 每个根节点代表一颗树
 */
export class TreeNode<T extends BaseEntity> {
  private _id: string;
  private _label: string;
  private _nodeValue: string;
  private _children: Array<TreeNode<T>>;
  private _data: T;
  private _isLeaf: boolean;

  constructor(id: string, label: string, nodeValue: string, isLeaf: boolean, data?: T) {
    this._id = id;
    this._label = label;
    this._nodeValue = nodeValue;
    this._isLeaf = isLeaf;
    if (data) {
      this._data = data;
    }
    this._children = new Array<TreeNode<T>>();
  }

  /** 节点的ID */
  get id() {
    return this._id;
  }

  /** 节点的文本 */
  get label() {
    return this._label;
  }

  /** 节点的选中值 */
  get nodeValue() {
    return this._nodeValue;
  }

  /** 子节点集合 */
  get children() {
    return this._children;
  }

  /** 节点的数据 */
  get data() {
    return this._data;
  }

  /** 是否是叶子节点 */
  get isLeaf() {
    return this._isLeaf;
  }

  /** 添加一个子节点 */
  public addChild(child: TreeNode<T>) {
    this._children.push(child);
  }

  /** 清空子节点 */
  public clearChildren() {
    this._children = new Array<TreeNode<T>>();
  }

  /**
   * 删除指定id的元素，如果不存在，则返回null
   * @param id 要删除的元素id
   * @returns 已经删除的元素
   */
  public removeChild(id: string): TreeNode<T> | null {
    const index = this._children.findIndex((item: TreeNode<T>) => item.id === id);
    if (index > -1) {
      return this._children.splice(index, 1)[0];
    }
    return null;
  }

  public toJson(): any {
    const json: any = {};
    json.id = this.id;
    json.label = this.label;
    json.nodeValue = this.nodeValue;
    json.data = this._data.toJson();
    json.children = [];
    this.children.forEach(element => {
      json.children.push(element.toJson());
    });
    return json;
  }

  public fromJson(json: any) {
    this._id = json.id;
    this._label = json.label;
    this._nodeValue = json.nodeValue;
    this._isLeaf = json.isLeaf;
    if (json.data !== null) {
      this._data.fromJson(json.data);
    } else {
      this._data = null;
    }
  }
}
